import { appLinkQueryEntries } from "./appLinkQueryEntries";
import { appOrigin } from "./appOrigin";

declare const appLinkBrand: unique symbol;

export type AppLink = string & { readonly [appLinkBrand]: true };
export type AppLinkPathPart = number | string;
export type AppLinkQueryScalar = boolean | number | string | null | undefined;
export type AppLinkQuery = Readonly<
  Record<string, AppLinkQueryScalar | readonly AppLinkQueryScalar[]>
>;

export interface BuildAppLinkOptions {
  hash?: string;
  query?: AppLinkQuery | URLSearchParams;
}

export function buildAppLink(
  pathParts: readonly AppLinkPathPart[] = [],
  options: BuildAppLinkOptions = {},
): AppLink {
  const path = pathParts
    .map((part) => String(part).replace(/^\/+|\/+$/gu, ""))
    .filter(Boolean)
    .map(encodeURIComponent)
    .join("/");
  const url = new URL(`/${path}`, appOrigin());

  const queryEntries = appLinkQueryEntries(options.query);

  for (const [name, rawValue] of queryEntries) {
    const values = Array.isArray(rawValue) ? rawValue : [rawValue];
    for (const value of values) {
      if (value === null || value === undefined) continue;
      url.searchParams.append(name, String(value));
    }
  }

  if (options.hash) url.hash = options.hash;

  return url.toString() as AppLink;
}
